export default __webpack_public_path__ + "static/media/qoshim.c82024f4.svg";